'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var getThemeProp = require('../utils/getThemeProp.js');
require('../utils/colors.js');
require('../utils/dates.js');
require('../utils/numbers.js');
require('../utils/PrintComponentGenerator/PrintComponentGenerator.js');
require('../utils/strings.js');
require('../utils/infiniteScrollCheckStateManager/infiniteScrollCheckStateManager.js');
require('../utils/pairedTableComponentGenerator/pairedTableComponentGenerator.js');
require('../utils/safeFetch.js');
require('../utils/dom.js');
var CircularProgress = _interopDefault(require('@material-ui/core/CircularProgress'));

var CircleLoadingSpinner = styled__default(CircularProgress)(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  &.MuiCircularProgress-colorPrimary {\n    color: ", ";\n  }\n"], ["\n  &.MuiCircularProgress-colorPrimary {\n    color: ", ";\n  }\n"])), getThemeProp('palette.text.hint', 'blue'));
var templateObject_1;

module.exports = CircleLoadingSpinner;
